export default __webpack_public_path__ + "static/media/ecran_2_je_rejoins_NL.7a42c10f.png";